import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { Factura } from 'src/app/Models/factura/factura';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { Filtro } from 'src/app/Models/filtro/filtro';

@Component({
  selector: 'app-anular-factura',
  templateUrl: './anular-factura.component.html',
  styleUrls: ['./anular-factura.component.css']
})
export class AnularFacturaComponent implements OnInit {
  @ViewChild('btnanularfactu', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('artinfo', null) artinfo: InfoComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  public funcion: Function;
  public isShow: boolean = false;
  public zindex: number = 10000;
  public factura: Factura = new Factura()
  public alertoption: ALertOption = new ALertOption()
  public filtro: Filtro = new Filtro()
  constructor(private data: DataService, private notify: NotifyService, private datepipe: DatePipe, private auth: AuthService) { }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    setTimeout(async () => {
      this.btnshow.nativeElement.click();
      this.artloading.show('Cargando datos');
      this.alertoption.showCancelButton = true
      //this.PrepararData();
      this.artloading.hide();
    }, 10);
  }

  close() {

    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 700);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

  buscarDocumento() {

    this.data.Post('filtrardoc/Factura', this.filtro).subscribe((r) => {
      console.log(r)
      this.factura = r.data[0]
    }, (error) => console.log(error)
    )
  }

  anularFactura() {
    this.factura.estado = "ANU"
    const payload = { motivo  : this.factura.motivonota, idfactura: this.factura.idfactura }
    this.data.Post('anular_pedido', payload).subscribe(r => {
      console.log(r.message);
      console.log(r);
      this.data.notify(r.message, "Exito", this.data.alertType.success)
      this.close()
    }, (error) => { this.artinfo.show(error.error.error) })
  }

  anularNubefact(idfactura) {
    this.data.GetFromId('anula_factura', idfactura).subscribe(r => {
      console.log(r);
    })
  }

  guardar() {
    if (!this.factura.motivonota) {
      this.data.notify("Ingrese un motivo", "Error", this.data.alertType.error)
    } else {
      this.data.notify("Desea anular este documento?", "Atencion", this.data.alertType.warning, this.alertoption, () => this.anularFactura(), null)
    }
  }

}
